<template>
  <div class="">
    <div class="head-title">自定义显示字段内容</div>
    <el-collapse style="margin-bottom: 2.0rem">
      <el-collapse-item title="帮助文档" name="1">
        <div class="help">
          <p>
            新增自定义字段时，单个确定以后统一点击下方“提交”按钮提交数据；修改时可以一起修改点击确定提交数据。总结：新增需点提交，修改无需
          </p>
        </div>
      </el-collapse-item>
    </el-collapse>

    <div class="">
      <div class="mMain">
        <div class="tianjia">
          <div class="cut">
            <span @click="leads()" :class="aaa == true ? 'a' : ''">线索</span>
            <span @click="customer()" :class="bbb == true ? 'a' : ''">客户</span>
            <span @click="business()" :class="eee == true ? 'a' : ''">商机</span>
            <span @click="agree()" :class="ddd == true ? 'a' : ''">合同</span>
            <span @click="returnMoney()" :class="fff == true ? 'a' : ''">回款</span>
            <span @click="applyExpense()" :class="ccc == true ? 'a' : ''">报销</span>
          </div>
          <div class="s_main">
            <div class="s_btn">
              <span @click="set = true" :class="set ? 'font a_font' : 'font'">系统字段</span>
              <span @click="set = false" :class="!set ? 'font a_font' : 'font'">自定义字段</span>
            </div>
            <div class="s_field" v-if="set">
              <div class="body_book">
                <div class="cell" v-for="(item, index) in liaotjl" :key="index">
                  <div class="label">{{ item.label }}</div>
                  <div class="value" v-if="item.if_gray">
                    <el-checkbox v-model="item.if_show" disabled>是否展示</el-checkbox>
                    <el-checkbox v-model="item.required" disabled>是否必填</el-checkbox>
                  </div>
                  <div class="value" v-else>
                    <el-checkbox v-model="item.if_show">是否展示</el-checkbox>
                    <el-checkbox v-model="item.required">是否必填</el-checkbox>
                  </div>
                </div>
              </div>
              <el-button type="primary" style="margin-left: 3.0rem" @click="submit">提交</el-button>
            </div>
            <div class="z_field" v-else>
              <selfField :state="auto"></selfField>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
import selfField from '@/components/selfField'
export default {
  components: {
    selfField
  },
  data() {
    return {
      data: {
        tableData: {}
      },
      checked: false,
      username: '',
      title: {},
      tooken: '',
      liaotjl: [],
      tabledataneo: [],
      aaa: true,
      bbb: false,
      ccc: false,
      ddd: false,
      eee: false,
      fff: false,
      auto: 'leads',
      set: true
    }
  },
  mounted() {
    // 页面刷新就请求到数据渲染到页面中
    // get请求页面的数据
    if (window.localStorage.getItem('storuser')) {
      let userinfo = JSON.parse(window.localStorage.getItem('storuser'))
      this.tooken = userinfo
    }
    this.getAE()
  },
  methods: {
    leads() {
      this.aaa = true
      this.bbb = false
      this.ccc = false
      this.ddd = false
      this.eee = false
      this.fff = false
      this.auto = 'leads'
      this.getAE()
    },
    customer() {
      this.aaa = false
      this.bbb = true
      this.ccc = false
      this.ddd = false
      this.eee = false
      this.fff = false
      this.auto = 'customer'
      this.getAE()
    },
    applyExpense() {
      this.aaa = false
      this.bbb = false
      this.ccc = true
      this.ddd = false
      this.eee = false
      this.fff = false
      this.auto = 'applyExpense'
      this.getAE()
    },
    agree() {
      this.aaa = false
      this.bbb = false
      this.ccc = false
      this.ddd = true
      this.eee = false
      this.fff = false
      this.auto = 'contract'
      this.getAE()
    },
    business() {
      this.aaa = false
      this.bbb = false
      this.ccc = false
      this.ddd = false
      this.eee = true
      this.fff = false
      this.auto = 'business'
      this.getAE()
    },
    returnMoney() {
      this.aaa = false
      this.bbb = false
      this.ccc = false
      this.ddd = false
      this.eee = false
      this.fff = true
      this.auto = 'receivables'
      this.getAE()
    },
    submit() {
      // let a = [];
      // for (var i = 0; i <= this.liaotjl.length - 1; i++) {
      //   if (this.liaotjl[i].if_show) {
      //     a.push(this.liaotjl[i]);
      // }
      //   }
      let len = this.liaotjl.length
      for (let i = 0; i < len; i++) {
        for (let j = i + 1; j < len; j++) {
          if (this.liaotjl[i].label === this.liaotjl[j].label) {
            this.liaotjl.splice(j, 1)
            len-- // 减少循环次数提高性能
            j-- // 保证j的值自加后不变
          }
        }
      }
      // console.log(this.liaotjl)
      this.axios
        .post(
          '/crm/ApplyExpense/custom_apply_filed',
          qs.stringify({
            account_id: this.tooken.account_id,
            state: this.auto,
            start_field: JSON.stringify(this.liaotjl)
          }),
          { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
        )
        .then(res => {
          if (res.data.code == 1) {
            // this.about();
            this.liaotjl = []
            this.getAE()
            this.$message({
              message: res.data.msg,
              type: 'success'
            })
          } else if (res.data.code == 0) {
            this.$message.error(res.data.msg)
          }
          if (res.data.msg == '登录超时') {
            this.$router.push('/register')
          }
        })
        .catch(function(err) {})
    },
    // 提交过后输出的数据\
    about() {
      this.axios
        .post(
          '/crm/CrmConfig/showFields',
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            types: this.auto
          }),
          { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
        )
        .then(res => {
          this.liaotjl = res.data.data
          if (res.data.msg == '登录超时') {
            this.$router.push('/register')
          }
          this.selected()
        })
        .catch(function(err) {})
    },
    selected() {
      this.axios
        .post(
          '/crm/CrmConfig/getFieldConfig',
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            types: this.auto
          }),
          { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
        )
        .then(res => {
          this.tabledataneo = res.data.data
          var a = this.liaotjl
          for (var i = 0; i <= this.liaotjl.length; i++) {
            for (var j = 0; j <= this.tabledataneo.length - 1; j++) {
              if (this.liaotjl[i].prop == this.tabledataneo[j].prop) {
                a[i].if_show = this.tabledataneo[j].if_show
                a[i].required = this.tabledataneo[j].required
              }
            }
          }
          this.liaotjl = a
          if (res.data.msg == '登录超时') {
            this.$router.push('/register')
          }
          res.data.data.forEach(item => {
            this.tableData.push(item)
          })
        })
        .catch(function(err) {})
    },
    async getAE() {
      const res = await this.axios({
        url: '/crm/ApplyExpense/get_custom_filed',
        method: 'POST',
        data: {
          account_id: this.tooken.account_id,
          state: this.auto
        }
      })
      if (res.data.code == 1) {
        this.liaotjl = res.data.data.start_field
        // console.log(this.liaotjl);
      }
    }
  }
  // 1.用户分配
  // 2.用户分配
  // 3.用户选择 附件管理
}
</script>
<style scoped>
.home {
  width: 100%;
  height: 100%;
}

.body_html {
  width: 100%;
  height: 100%;
}

.wei_body {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  box-shadow: .0rem .1rem .6rem .0rem rgba(0, 0, 0, 0.2);
  padding: 2.3rem 3.1rem;
}

.tianjia {
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
}

.tianjia > main {
  font-size: 2.3rem;
  margin-bottom: 2.0rem;
}

.bule {
  width: 100%;
  height: 6.9rem;
  background-color: #2890dd;
  z-index: 10;
  position: absolute;
  top: .0rem;
  left: .0rem;
}

.body_book {
  padding: 2.0rem;
}

.cell {
  margin: 2.0rem 0;
  display: flex;
}

.label {
  min-width: 12.0rem;
  margin-right: 2.0rem;
  text-align: right;
  font-size: 1.6rem;
  font-weight: 400;
  color: #303133;
  line-height: 2.0rem;
}

/* .label::after {
  content: ':';
} */

.body_book > div > div:nth-child(1) {
  margin-bottom: 1.0rem;
}

.cut {
  /* border-bottom: .1rem solid #eee; */
  background-color:#f8f8f8;
}

.cut > span {
  display: inline-block;

  cursor: pointer;

  padding:2.0rem 5.9rem;
  font-weight: 400;
  font-size: 2.1rem;

}

/* .cut > span:nth-child(2) {
  border-left: .0rem;
} */
.a {
font-weight: 600 !important;
color: #49B372;
background-color:#fff !important ;
border-radius: 0.8rem 0.8rem 0 0;
}

.staffo_home {
  width: 100%;
  height: 100%;
}

.s_btn {
  padding: 2.7rem .0rem;
  border-bottom: .1rem solid #eee;
  margin:.0rem 3.0rem;
}

.font {
  margin: 0 3.0rem;
  cursor: pointer;
  padding: 2.7rem .0rem;
  font-size: 1.8rem;

font-weight: 500;

line-height: 2.5rem;
}

.a_font {
  color: #49B372;
  border-bottom:.1rem  #49B372 solid;


}

.s_main {
  /* margin-top: 1.0rem; */

}

.z_field {
  padding: 2.0rem;
}
.mMain{
  padding: 0rem 0rem 2rem !important;
  background-color:#fff  !important;
}
.el-checkbox__input.is-disabled+span.el-checkbox__label{
  color: #bbbbbb !important;
}
</style>
